import cn from 'clsx'
import { Div } from 'components/staticpages/blocks/frontpage/mediaandtext2021'
import { Pill, Link, IconArrow } from '@tracklib/kit'
import styles from './centeredtext.css'

type CenteredTextProps = {
  title?: string
  label?: string
  description?: string
  link_text?: string
  link_url?: string
  className?: string
}

const CenteredText = ({ link_url, label, link_text, description, title, className }: CenteredTextProps): JSX.Element => {
  const TextContent = link_url ? Link : Div
  return (
    <div className={cn(styles.textWrapper, className)}>
      <TextContent to={link_url} className={styles.text}>
        {label && <Pill>{label}</Pill>}
        {title && <h2 className={styles.title}>{title}</h2>}
        {description && <p className={styles.description}>{description}</p>}
        {link_text && (
          <p className={styles.fakeLink}>
            {link_text} <IconArrow className={styles.arrowRight} />
          </p>
        )}
      </TextContent>
    </div>
  )
}

export default CenteredText
